const CIDADES_ABREV = {
  'sp': 'São Paulo',
  'rj': 'Rio de Janeiro',
  'ctba': 'Curitiba',
  'poa': 'Porto Alegre',
  'bh': 'Belo Horizonte'
}

export {
  CIDADES_ABREV
}
